import React from 'react'
import { Trans } from '@lingui/react'

import OnboardingModal from '../../onboarding/OnboardingModal'

const AdminOnboardingModalWelcome = ({ ...props }) => (
    <OnboardingModal
        title={<Trans id="Welcome" />}
        subTitle={
            <>
                <Trans id="We have succesfully setup a new company for you" />
                <br />
                <Trans id="Before we get started, we need to set a few general settings" />
            </>
        }
        {...props}
    />
)

export default AdminOnboardingModalWelcome
